import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import { ConfirmAlert } from 'modules/common/components/Alert';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../../action';
import * as c from '../../constant';

function StructuralMaterialsModal({
  handleOnParent,
  closeModal,
  dataInfo,
  getSingleMaterialType,
  getBuildingMaterialTypeList,
  buildingTypeMaterialList,
  materialList,
  getSingleMaterial,
  type,
}) {

  const [formData, setFormData] = useState({
    rptax_building_material_type_id: '',
    rptax_building_material_id: '',
    floor: '',
  });

  const validateForm = useFormValidator(formData, {
    rptax_building_material_type_id: 'required',
    rptax_building_material_id: 'required',
  });

  const closeOwnModal = (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to cancel adding material?',
      () => {
        closeModal();
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    if (!_.isEmpty(dataInfo)) {
      setFormData({
        ...formData,
        id: _.get(dataInfo, 'id'),
        rptax_building_material_id: _.get(dataInfo, 'rptax_building_material_id'),
        rptax_building_material_type_id: _.get(dataInfo, 'rptax_building_material_type_id'),
        rptax_building_material_type_name: _.get(dataInfo, 'rptax_building_material_type_name'),
        material_name: _.get(dataInfo, 'rptax_building_material_name'),
        floor: _.get(dataInfo, 'floor'),
      });
      getSingleMaterialType(_.get(dataInfo, 'rptax_building_material_type_id'));
    }
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      rptax_building_material_id: formData.rptax_building_material_id,
      rptax_building_material_type_id: formData.rptax_building_material_type_id,
      rptax_building_material_type_name: formData.rptax_building_material_type_name,
      material_name: formData.material_name,
      floor: formData.floor,
    };

    if (!validateForm.response.is_passed) {
      return false;
    }

    handleOnParent(args);
    closeModal();
    return false;
  };

  const handleOnChangeSelect = key => (e) => {
    if (key === 'rptax_building_material_type_id') {
      getSingleMaterialType(e.value);
      setFormData({
        ...formData,
        [key]: e.value,
        rptax_building_material_id: '',
      });
    }
    if (key === 'rptax_building_material_id') {
      getSingleMaterial(formData.rptax_building_material_type_id, e.value, (data) => {
        setFormData({
          ...formData,
          [key]: +_.get(data, 'data.id'),
          material_name: _.get(data, 'data.attributes.name'),
          rptax_building_material_type_name: _.get(data, 'data.attributes.building_material_type.description'),
        });
        getSingleMaterialType(formData.rptax_building_material_type_id);
      })
    }
  };

  useEffect(() => {
    getBuildingMaterialTypeList({ status:1, type });
  }, []);

  const buildingTypeMaterialOptions = buildingTypeMaterialList.map((x) => {
    return {
      value: +x.id,
      label: x.attributes.name,
    };
  });

  const materials = _.get(materialList, 'attributes.materials') || [];

  const materialOptions = materials.map((x) => ({
    label: x.name,
    value: +x.id,
  }));

  return (
    <Modal.Body>
      <div>
        <div className="row">
          <div className="col-6 form-group">
            <label htmlFor="first_name" className="form-label mb-1">
              Building Material Type {validateForm.renderMessage('rptax_building_material_type_id')}
            </label>
            <Select
              value={buildingTypeMaterialOptions.filter(item => _.get(formData, 'rptax_building_material_type_id') === _.get(item, 'value')) || ''}
              onChange={handleOnChangeSelect('rptax_building_material_type_id')}
              options={buildingTypeMaterialOptions}
              placeholder="Select Building Material Type"
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="first_name" className="form-label mb-1">
              Building Material {validateForm.renderMessage('rptax_building_material_id')}
            </label>
            <Select
              isDisabled={formData.rptax_building_material_type_id === ''}
              value={
                materialOptions.find(
                  (x) => +x.value === +_.get(formData, 'rptax_building_material_id')
                ) || ''
              }
              onChange={handleOnChangeSelect('rptax_building_material_id')}
              options={materialOptions}
              placeholder="Select Building Material"
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>
        </div>
        <hr className="below-hr" />
        <div className="d-flex justify-content-center mt-5">
          <button
            type="button"
            onClick={closeOwnModal}
            className="btn btn-light button-cancel-2 mr-1"
            style={{ backgroundColor: '#323943', color: '#fff' }}
          >
            Back
          </button>
          <button
            type="submit"
            onClick={handleOnSubmit}
            className="btn btn-light button-proceed ml-1 cms-bg-color-primary"
            style={{ color: '#fff' }}
            disabled={!validateForm.response.is_passed}
          >
            Submit
          </button>
        </div>
      </div>
    </Modal.Body>
  );
}

StructuralMaterialsModal.defaultProps = {
  dataInfo: {},
  type: ''
};

StructuralMaterialsModal.propTypes = {
  dataInfo: PropTypes.instanceOf(Object),
  handleOnParent: PropTypes.instanceOf(Function).isRequired,
  closeModal: PropTypes.instanceOf(Function).isRequired,
  getSingleMaterialType: PropTypes.instanceOf(Function).isRequired,
  materialList: PropTypes.instanceOf(Object).isRequired,
  getBuildingMaterialTypeList: PropTypes.instanceOf(Function).isRequired,
  buildingTypeMaterialList: PropTypes.instanceOf(Array).isRequired,
  getSingleMaterial: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  buildingTypeMaterialList: _.get(api, `${c.GET_BUILDING_MATERIAL_TYPE}.list`) || [],
  materialList: _.get(api, `${c.GET_SINGLE_BUILDING_MATERIAL_TYPE}.item`) || {},
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(StructuralMaterialsModal);